export const isHolidayPast = (dateStr) => {
  if (!dateStr) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today > new Date(`${dateStr}T00:00:00`);
};

const getOrdinal = (n) => {
  if (n > 3 && n < 21) return "th";
  switch (n % 10) {
    case 1: return "st";
    case 2: return "nd";
    case 3: return "rd";
    default: return "th";
  }
};

export const formatHolidayDate = (dateStr) => {
  if (!dateStr) return "";
  // append T00:00:00 to force local time, not UTC
  const date = new Date(`${dateStr}T00:00:00`);
  const month = date.toLocaleDateString("en-NZ", { month: "long" });
  const dayOfWeek = date.toLocaleDateString("en-NZ", { weekday: "long" });
  const day = date.getDate();
  return `${month}, ${dayOfWeek} ${day}${getOrdinal(day)}`;
};
